// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.settings-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.settings-header h1 {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e2a3a;
}

.settings-header p {
  margin: 0;
  color: #6b7785;
  font-size: 0.95rem;
}

.settings-card {
  background: #ffffff;
  border: 1px solid #e5e9ef;
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
}

.settings-card-title {
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1e2a3a;
}

.settings-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.settings-column {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.settings-muted {
  color: #8791a0;
  font-size: 0.8rem;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/Settings/AISettings.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".settings-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.settings-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.settings-header h1 {\n  margin: 0;\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #1e2a3a;\n}\n\n.settings-header p {\n  margin: 0;\n  color: #6b7785;\n  font-size: 0.95rem;\n}\n\n.settings-card {\n  background: #ffffff;\n  border: 1px solid #e5e9ef;\n  border-radius: 12px;\n  padding: 1.25rem 1.5rem;\n  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);\n}\n\n.settings-card-title {\n  margin: 0 0 0.75rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1e2a3a;\n}\n\n.settings-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.settings-column {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.settings-muted {\n  color: #8791a0;\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
